import type { ITheme } from '@xterm/xterm';

const style = getComputedStyle(document.documentElement);
const cssVar = (token: string) => style.getPropertyValue(token) || undefined;

export function getTerminalTheme(overrides?: ITheme): ITheme {
  return {
    cursor: cssVar('--alpha-elements-terminal-cursorColor'),
    cursorAccent: cssVar('--alpha-elements-terminal-cursorColorAccent'),
    foreground: cssVar('--alpha-elements-terminal-textColor'),
    background: cssVar('--alpha-elements-terminal-backgroundColor'),
    selectionBackground: cssVar('--alpha-elements-terminal-selection-backgroundColor'),
    selectionForeground: cssVar('--alpha-elements-terminal-selection-textColor'),
    selectionInactiveBackground: cssVar('--alpha-elements-terminal-selection-backgroundColorInactive'),

    // ansi escape code colors
    black: cssVar('--alpha-elements-terminal-color-black'),
    red: cssVar('--alpha-elements-terminal-color-red'),
    green: cssVar('--alpha-elements-terminal-color-green'),
    yellow: cssVar('--alpha-elements-terminal-color-yellow'),
    blue: cssVar('--alpha-elements-terminal-color-blue'),
    magenta: cssVar('--alpha-elements-terminal-color-magenta'),
    cyan: cssVar('--alpha-elements-terminal-color-cyan'),
    white: cssVar('--alpha-elements-terminal-color-white'),
    brightBlack: cssVar('--alpha-elements-terminal-color-brightBlack'),
    brightRed: cssVar('--alpha-elements-terminal-color-brightRed'),
    brightGreen: cssVar('--alpha-elements-terminal-color-brightGreen'),
    brightYellow: cssVar('--alpha-elements-terminal-color-brightYellow'),
    brightBlue: cssVar('--alpha-elements-terminal-color-brightBlue'),
    brightMagenta: cssVar('--alpha-elements-terminal-color-brightMagenta'),
    brightCyan: cssVar('--alpha-elements-terminal-color-brightCyan'),
    brightWhite: cssVar('--alpha-elements-terminal-color-brightWhite'),

    ...overrides,
  };
}
